import produce from 'immer';
import _ from 'lodash';
import objFromArray from 'src/utils/objFromArray';
import {
  GET_ALL_CUSTOM_ACTIONS,
  ADD_CUSTOM_ACTION,
  UPDATE_CUSTOM_ACTION,
  DELETE_ACTION
} from 'src/actions/customActions';

const initialState = {
  allIds: [],
  byId: {}
};

const customActionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CUSTOM_ACTIONS: {
      const { customActions } = action.payload;
      return produce(state, draft => {
        draft.byId = objFromArray(customActions);
        draft.allIds = Object.keys(draft.byId);
      });
    }

    case ADD_CUSTOM_ACTION: {
      const { customAction } = action.payload;
      return produce(state, draft => {
        draft.byId[customAction.id] = customAction;
        if (!draft.allIds.includes(customAction.id)) {
          draft.allIds.push(customAction.id);
        }
      });
    }
    case UPDATE_CUSTOM_ACTION: {
      const { customAction } = action.payload;
      return produce(state, draft => {
        draft.byId[customAction.id] = customAction;
        if (!draft.allIds.includes(customAction.id)) {
          draft.allIds.push(customAction.id);
        }
      });
    }
    case DELETE_ACTION: {
      const { actionId } = action.payload;
      return produce(state, draft => {
        draft.byId = _.omit(draft.byId, actionId);
        _.pull(draft.allIds, actionId);
      });
    }

    default: {
      return state;
    }
  }
};

export default customActionReducer;
